import { TRootState } from 'Redux/Reducers';

export const getMauDauWau = (state: TRootState) => {
  return {
    mau: state.sales.entries.mau || [],
    wau: state.sales.entries.wau || [],
    dau: state.sales.entries.dau || [],
  };
};
